
export default {
    data() {
        return {
            val: {}
        }
    },
    watch: {
        data() {
            this.val = this.$deepClone(this.data)
        }
    },
    mounted() {
        this.val = this.$deepClone(this.data)
    },
    methods: {
        dataChange() {
            this.$emit('update:data', this.val)
        }
    }

}